﻿export { PipeProfile };

const PipeProfile = function () {

    // Define this
    var myPipeProfile = this;

    // Properties
    this.primaryColor = '#4cff4c';
    this.secondaryColor = '#6666ff';

    // -- begin public methods ---------------------------------------------------------------------

    /* API */

    /**
     * getProfileAnalysis
     * Calls the service with requested waste water elements to analyse for profile
     * @param {callData} callURLParams, chartElementId, dataTable, utility, toastr
     * @param {callData}
     *          callData.callURLParams: Parameters for Pipe Profile web service call
     *          callData.chartElementId: Chart ID on page. If not provided, a modal with a new chart is generated
     *          callData.dataTable: Datatable ID to fill in report, if provided
     *          callData.utility: Utility object
     *          callData.toastr: Toastr object
     */
    this.getProfileAnalysis = function (callData) {

        var callURL = '/rest/app/WaterWaste/GetPipeProfile?' + callData.callURLParams;

        $.ajax({
            type: 'GET',
            url: callURL,
            async: true,
            success: function (data) {
                if (data.error) {
                    callData.toastr["error"]("Erro na identificação do perfil");
                }
                else {
                    switch (data.result.status) {

                        case "NOT CONNECTED":
                            callData.toastr["error"]("Os pontos não têm ligação na rede.");
                            break;
                        case "SUCCESS":

                            // Handle Profile Data 
                            var profile_data = data.result.list_ww_pipe_profile_analysis;

                            // Format profile data
                            profile_data = myPipeProfile.formatChartData(profile_data);

                            // Draw Profile Data Chart
                            myPipeProfile.drawChart(profile_data, { chartElementId: callData.chartElementId, idAnalysis: data.result.idAnalysis });

                            // If there data table initialization called
                            if (typeof callData.dataTable != 'undefined' && callData.dataTable) {
                             
                                var profileTable = myPipeProfile.initProfileTable();

                                myPipeProfile.addTableData(profileTable, profile_data);
      
                            }

                            callData.toastr["success"]("Sucesso na identificação do perfil");
                            break;
                        default:
                            callData.toastr["error"]("Erro na identificação do perfil");
                    }
                }
                // ShowWait
                callData.utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                callData.toastr["error"]("Erro na identificação do perfil");
                // ShowWait
                callData.utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /* Report */

    /**
     * Add Table Data
     * Adds data rows to Pipe Profile Report Table
     * @param table: Data table to increment
     * @param data: Data from database
     */
    this.addTableData = function (table, data) {
        
        var tableRowData = [];
        var previousX = 0;
        var previousManhole = '';

        $(data.elementLabels).each(function (i) {

            // Get origin data
            var elements = data.elementLabels[i]; // Manhole and Pipe info
            var label = data.labels[i]; // Current X
            var elementData = elements.split('.'); // Manhole and Pipe codes
            var manhole = elementData[0]; // Manhole Code
            var pipe = elementData[1]; // Pipe Code

            // If pipe is not empty, it is not initial row - add to table
            if (pipe != '') {
                // Add data for table addition
                tableRowData.push({
                    ww_pipe: pipe,
                    ww_manhole_upstream: previousManhole,
                    ww_manhole_downstream: manhole,
                    previous_x: previousX,
                    current_x: label
                });
            }
            previousX = label;
            previousManhole = manhole;

        });

        $(tableRowData).each(function (i) {

            table.row.add(tableRowData[i]);

        });

        table.draw();

    }

    /**
     * Init Profile Table
     * Initializes Pipe Profile Report Table
     * @param chartData: Profile data from database
     */
    this.initProfileTable = function () {
        // -- init column def --
        var columnDefArray = [];

        // Occurrence event total
        var objDef = {
            'data': 'ww_pipe',
            'title': 'Coletor',
            'name': 'Coletor',
            'label': 'Coletor',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);
        // state "em Análise"
        objDef = {
            'data': 'ww_manhole_upstream',
            'title': 'Câmara Visita Montante',
            'name': 'Câmara Visita Montante',
            'label': 'Câmara Visita Montante',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);
        // state "Em resolução"
        objDef = {
            'data': 'ww_manhole_downstream',
            'title': 'Câmara Visita Justante',
            'name': 'Câmara Visita Justante',
            'label': 'Câmara Visita Justante',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);
        // state "Fechado"
        objDef = {
            'data': 'previous_x',
            'title': 'Distância inicial',
            'name': 'Distância inicial',
            'label': 'Distância inicial',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);
        // state "Cancelado"
        objDef = {
            'data': 'current_x',
            'title': 'Distância final',
            'name': 'Distância final',
            'label': 'Distância final',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-occurrence-neighbor',
            'width': '60px'
        };
        columnDefArray.push(objDef);

        return $('#id-profile-analysis-report-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Sem estruturas para análise',
            },
            "fixedHeader": true,
            "info": false,
            "autoWidth": false,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": false,
            "ordering": false,
            "columns": columnDefArray,
            "select": false,
            "name": "occurrence_report_global_event"
        });
    }

    /* CHART */

    /**
     * Format Chart Data
     * Returns database information in the format required for chart generation
     * @param chartData: Profile data from database
     */
    this.formatChartData = function (chartData) {

        var labels = [];
        var elementLabels = [];
        var elementValues = [];
        var dataManhole = [];
        var dataPipe = [];
        var max = chartData[0].y_ground;
        var min = chartData[0].y;

        for (var i = 0; i < chartData.length; i++) {

            // Set Manhole and Pipe Codes
            elementLabels.push(chartData[i].manhole_code + '.' + (chartData[i].pipe_code == null ? '' : chartData[i].pipe_code));

            // Set element extra values
            elementValues.push({ inclination_perc: chartData[i].inclination_perc });

            // Set x Labels
            labels.push(Math.round(chartData[i].x * 100) / 100);

            // Set data for manhole (ground) level dataset
            dataManhole.push({ x: chartData[i].x, y: chartData[i].y_ground });

            // Set data for pipe line level dataset
            dataPipe.push({ x: chartData[i].x, y: chartData[i].y }); 

            // Calculate Max and Min values for chart
            if (chartData[i].y_ground < min) {
                min = chartData[i].y;
            }
            if (chartData[i].y_ground > max) {
                max = chartData[i].y_ground;
            }
        }

        // Set Max and Min values for chart
        min = min > 10 ? min - 10 : min;
        max = max + 50;

        var formatedData = {
            labels: labels,
            elementLabels: elementLabels,
            elementValues: elementValues,
            data: [dataManhole, dataPipe],
            max: max,
            min: min
        }

        return formatedData;
    }

    /**
     * Draw Chart
     * Draws a chart for given profile data 
     * @param data: Profile data from database
     * @param {options} 
     *          options.chartElementId: default chartContainer, receives ID if static chart on page; 
     *          options.idAnalysis: Id from the analysis to be drawn
     */
    this.drawChart = function (data, options) {

        var idAnalysis = typeof options.idAnalysis != 'undefined' ? options.idAnalysis : 0;

        if (typeof options.chartElementId != 'undefined') {

            myPipeProfile.instantiateChart(data, { chartElementId: 'chartContainer', static: true });

        } else {

            myPipeProfile.instantiateModal(data, options.idAnalysis); 

        }

    } 

    /**
     * Instantiate Modal
     * Creates and shows a modal with a profile chart for the requested data
     * @param data: Profile data from database
     * @param idAnalysis: Id from the analysis to be drawn
     */
    this.instantiateModal = function (data, idAnalysis) {

        var idAnalysis = typeof idAnalysis == 'undefined' ? 0 : idAnalysis;

        $('#chart-modal').remove();

        $('body').append(
            '<div class="modal fade" id="chart-modal" role="dialog" style="padding-top: 0">' +
            '  <div class="modal-dialog" style="width: 70vw">' +
            '    <div class="modal-content" style="width: 100% !important">' +
            '      <div class="modal-header">' +
            '        <button type="button" class="close" data-dismiss="modal">&times;</button>' +
            '        <h4 class="modal-title">Perfil de Saneamento</h4>' +
            '      </div>' +
            '      <div class="modal-body" style="height: calc(75vh);overflow-y: auto;">' +
            '       <canvas id="chartContainer"></canvas>' +
            '      </div>' +
            '      <div class="modal-footer" style="padding:20px">' +
            //'        <button type="button" class="btn btn-link" data-dismiss="modal">Voltar</button>' +
            '       <button type="submit" id="export-profile-analysis" id-analysis="' + idAnalysis + '" title="Gerarrelatório" class="btn btn-primary pull-right">Guardar</button>' +
            '      </div>' +
            '    </div>' +
            '  </div>' +
            '</div>');

        $('#export-profile-analysis').click(function () {
            var url = '/ReportProfileAnalysis?idAnalysis=' + $(this).attr('id-analysis');
            window.open(url, '_blank');
        });

        $('#chart-modal').off('shown.bs.modal').on('shown.bs.modal', function (e) {

            myPipeProfile.instantiateChart(data);

        }).modal('show');

    }

    /**
     * Instantiate Chart
     * Creates and shows a profile chart for the requested data
     * @param data: Profile data from database
     * @param {options}
     *          options.chartElementId: default chartContainer, Id for the chart canvas container;
     *          options.static: If true, chart events, animation and tooltips disabled. Default false
     */
    this.instantiateChart = function (data, options) {

        var chartElementId =    typeof options != 'undefined'
            && options.chartElementId != 'undefined' ? options.chartElementId : 'chartContainer';
        var staticChart = typeof options != 'undefined'
            && options.static != 'undefined' ? options.static : false;
        var canvas = document.getElementById(chartElementId);
        var ctx = canvas.getContext('2d');

        var chartLayers = function () {

            Chart.controllers.line.prototype.draw.call(this, arguments);

            var chartInstance = this.chart;
            var chartTopMargin = chartInstance.chart.chartArea["top"];
            var chartBottomMargin = chartInstance.chartArea['bottom'];
            var chartRightMargin = chartInstance.chartArea['right'];

            ctx.font = Chart.helpers.fontString(16, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
            ctx.font = '10px Arial';
            ctx.fillStyle = "#000";
            var labelWidth = 100;
            var previousPipeLength = 0;
            var previousX = 0;

            // For first dataset draw labels and lines
            var meta = chartInstance.controller.getDatasetMeta(0);

            // For each data point print manhole name
            meta.data.forEach(function (line, index) {
                
                // Draw Manhole Label
                var labels = chartInstance.data.elementLabels[index].split('.');
                var manholeLabel = labels[0];
                var xOffset = line._model.x;
                var yOffset = line._model.y;
                var currentPipeLength = xOffset - previousX;
                var meanLength = 0; // Space between mean point from pipe to pipe

                meanLength = (currentPipeLength + previousPipeLength) / 2;

                ctx.save();
                
                // Check space available for manhole label, and draw accordingly
                if (meanLength > labelWidth - 10) {
                    ctx.fillText(manholeLabel, xOffset - (labelWidth / 2) + 10, yOffset - 70);
                } else if (meanLength > labelWidth - 30) {
                    ctx.translate(xOffset - (labelWidth / 2) + 20, yOffset - 40);
                    ctx.rotate(-0.25 * Math.PI); // Rotate text (oblique)
                    ctx.fillText(manholeLabel, 0, 0);
                } else {
                    ctx.font = '9px Arial';
                    ctx.translate(xOffset, yOffset - 60);
                    ctx.rotate(-0.5 * Math.PI); // Rotate text (vertical)
                    ctx.fillText(manholeLabel, 0, 0);
                }

                ctx.restore(); // Restore initial rotation

                // Draw Manhole Chart Line
                ctx.beginPath();
                ctx.moveTo(xOffset, chartBottomMargin);
                ctx.strokeStyle = '#000';
                ctx.lineTo(xOffset, yOffset - 50);                
                ctx.closePath();
                ctx.stroke();

                previousX = xOffset;
                previousPipeLength = currentPipeLength;

            });           

            // Get all data for each dataset 
            chartInstance.data.datasets.forEach(function (dataset, i) {

                var meta = chartInstance.controller.getDatasetMeta(i);
                var data = dataset.data;
                ctx.font = '10px Arial';
                ctx.fillStyle = "#000";

                // For pipe dataset draw labels and lines
                if (i == 1) {

                    var previousX = 0; // Keeps previous data point x value
                    var firstElevation; // Keeps the elevation info for first data point
                    var lastElevation; // Keeps the elevation info for last data point
                    var pipeGroupLength = 0; // Length for all the network (from data) 
                    var pipeCount = 0; // How many pipes in network

                    // For each data point print pipe information
                    meta.data.forEach(function (line, index) {

                        var labels = chartInstance.data.elementLabels[index].split('.');
                        var values = chartInstance.data.elementValues[index];
                        var pipeLabel = labels[1];
                        var xOffset = line._model.x;
                        var yOffset = line._model.y;
                        if (typeof firstElevation == 'undefined') firstElevation = data[index].y;
                        var pipeChartLength = 0;
                        pipeGroupLength = data[index].x;

                        pipeChartLength = xOffset - previousX;

                        // Print Pipe Label in the center of the pipe length area
                        if (pipeLabel != '') { // First record does not have pipe (signals first manhole)

                            pipeCount++;
                            var midPipePos = (xOffset + previousX) / 2;

                            if (pipeChartLength > labelWidth - 10) {

                                ctx.restore(); // Restore rotation to initial
                                ctx.fillText(pipeLabel, midPipePos - 37, chartBottomMargin - 50);

                            } else {

                                ctx.restore(); // Restore rotation to initial
                                ctx.save();

                                if (pipeChartLength > labelWidth - 30) {
                                    ctx.translate((xOffset + previousX) / 2 - 25, chartBottomMargin - 50);
                                    ctx.rotate(-0.25 * Math.PI); // Rotate text (oblique)
                                } else {
                                    ctx.translate((xOffset + previousX) / 2, chartBottomMargin - 50);
                                    ctx.rotate(-0.5 * Math.PI); // Rotate text (vertical)
                                }

                                ctx.fillText(pipeLabel, 0, 0); // Print pipe label

                            }

                            // Print inclination
                            ctx.restore();
                            var inclination = values.inclination_perc == 0 ? '(0,00%)' : '(' + values.inclination_perc + '%)';
                            ctx.fillText(inclination, midPipePos - 15, chartBottomMargin - 20);
                        }


                        previousX = xOffset;
                        lastElevation = data[index].y;

                    });

                    // Print total inclination (when more than one pipe considered)
                    if (pipeCount > 1) {
                        var elevationDifference = (lastElevation - firstElevation);
                        var totalInclination = Math.round((elevationDifference / pipeGroupLength * 100.0) * 100) / 100;
                        totalInclination = totalInclination == 0 ? '(0,00%)' : '(' + totalInclination + '%)';
                        ctx.fillText(totalInclination, chartRightMargin / 2, chartTopMargin - 30);
                    }

                }

            });

            ctx.restore(); // Restore canvas original orientation and style
        }

        // Create custom chart type
        Chart.defaults.derivedLine = Chart.defaults.line;

        var customChart = Chart.controllers.line.extend({
            draw: chartLayers
        });

        Chart.controllers.derivedLine = customChart;

        var animation = false;
        var tooltips = { enabled: false };
        var legend = {
            position: 'bottom',
            onClick: (e) => e.stopPropagation()          
        }
        var events = [];
        if (!staticChart) {
            animation = {
                duration: 800,
                easing: 'linear',
                xAxis: true,
                yAxis: true
            };
            tooltips.enabled = true;
            legend = { position: 'bottom' };
            events = ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'];
        }
        // Set Chart basic options
        var chartOptions = {
            layout: {
                padding: {
                    bottom: 10,
                    left: 10,
                    right: 10,
                    top: 70
                }
            },
            title: {
                display: false
            },
            scales: {
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'Cota (m)'
                    },
                    gridLines: {
                        color: '#000',
                        display: true,
                        drawOnChartArea: false,
                        drawBorder: true
                    },
                    offset: true,
                    ticks: {
                        suggestedMin: data.min,
                        beginAtZero: false,
                        max: data.max,
                        padding: 5
                    }
                }],
                xAxes: [{
                    //type: 'linear',
                    offset: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Comprimento (m)'
                    },
                    gridLines: {
                        color: '#000',
                        display: true,
                        drawOnChartArea: false,
                        drawBorder: true
                    },
                    ticks: {
                        padding: 5
                    }
                }]
            },
            animation: animation,
            tooltips: tooltips,
            legend: legend,
            events: events
        };

        // Instantiate new Chart JS
        var chart = new Chart(ctx, {
            type: 'derivedLine',
            responsive: true,
            data: {
                labels: data.labels,
                elementLabels: data.elementLabels,
                elementValues: data.elementValues,
                datasets: [
                    // Manhole Dataset
                    {
                        label: "Terreno",
                        lineTension: 0,
                        backgroundColor: 'transparent',
                        borderColor: myPipeProfile.primaryColor,
                        data: data.data[0]
                    },
                    // Pipe dataset
                    {
                        label: "Coletor",
                        lineTension: 0,
                        backgroundColor: 'transparent',
                        borderColor: myPipeProfile.secondaryColor,
                        data: data.data[1]
                    }]
            },
            options: chartOptions
        });

        window['chart1'] = chart; // Control variable

    }

    // -- end public method -----------------------------------------------------------------------
};